import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Lookalike Specialists',
		description:
			'Exclusively hire celebrity impersonators. Nobody has noticed yet.'
	},
	{
		name: 'Hologram Appearances',
		description:
			'Replace real celebrities with glitchy holograms that occasionally malfunction.'
	},
	{
		name: 'AI Generated Stars',
		description:
			'Create completely fake celebrities using AI. Their backstories keep changing.'
	},
	{
		name: 'Quantum Superstar',
		description:
			'Book celebrities who exist in a quantum state of being both famous and unknown.'
	},
	{
		name: 'Time-Traveling Icons',
		description:
			"Book historical figures for campaign events. The paradoxes are someone else's problem."
	},
	{
		name: 'Multiverse Stars',
		description:
			'Book celebrities from parallel universes where they made different career choices.'
	},
	{
		name: 'Void Celebrity Division',
		description:
			'Book appearances with beings from the void. Very mysterious, very trendy.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Celebrity Booking Agency'],
	departments[DepartmentIds['Celebrity Booking Agency']].basePrice * 3,
	UpgradeIds.CbaExponent1
)

export default array
